import { not } from './boolean.no-deps'
import { compose } from './compose.no-deps'

export interface Identifiable {
    id: number
}

export function hasId(id: number) {
    return <T extends Identifiable>(entity: T) => entity.id === id
}

export const doesNotHaveId = (id: number) => compose(hasId(id), not)

export function findById<T extends Identifiable>(entities: T[], id: number) {
    return entities.find(hasId(id))
}

export function getIds<T extends Identifiable>(entities: T[]) {
    return entities.map((e) => e.id)
}

export function removeById(id: number) {
    return <T extends Identifiable>(entities: T[]) => entities.filter(doesNotHaveId(id))
}

export function updateById<T extends Identifiable>(id: number, fn: (entity: T) => T) {
    return (entities: T[]) => entities.map((entity) => (entity.id === id ? fn(entity) : entity))
}
